exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.friendlist[data-v-3a37e722]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end\n}\ntable tr:not(:last-of-type) td[data-v-3a37e722]{border-bottom:1px solid #8a734b\n}\n.avatar[data-v-3a37e722]{margin:0 auto\n}\n.username[data-v-3a37e722]{font-size:21px\n}\n.level[data-v-3a37e722]{font-size:13px\n}\n", ""]);

// exports
